import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components';
import React from 'react';
import { assetUrl } from '~/helpers';
import SeeAllBonjoroPlans from '~/App/Components/Buttons/SeeAllBonjoroPlans';
import cx from 'classnames';

export enum TitlePosition {
  Top = 'top',
  MainContent = 'main-content',
}

export interface SignUpForFullBonjoroExperienceProps {
  title: string;
  titlePosition?: TitlePosition;
  parentWrapperClassName?: string;
  imageWrapperClassName?: string;
  mainContentClassName?: string;
}

const SignUpForFullBonjoroExperience = ({
  title,
  titlePosition = TitlePosition.MainContent,
  parentWrapperClassName,
  imageWrapperClassName,
  mainContentClassName,
}: SignUpForFullBonjoroExperienceProps) => {
  const header = <h2 className='mt-0 mb-4 text-black font-bold'>{title}</h2>;

  return (
    <div className={cx(['flex', parentWrapperClassName])}>
      {titlePosition === TitlePosition.Top && header}
      <div className={cx(['p-2 lg:p-0 text-center', imageWrapperClassName])}>
        <img
          src={assetUrl('assets/images/modals/full-experience-banner.png')}
          className='max-w-[265px]'
        />
      </div>
      <div className={cx(['px-5 text-center mb-2', mainContentClassName])}>
        {titlePosition === TitlePosition.MainContent && header}
        <p className='mb-4 pt-2'>
          Sign up now and enjoy access to custom branding and subdomains, more
          video messages and templates, workflows, and more.
        </p>

        <a href='/auth/logout?redirect=auth::register' className='mr-4'>
          <Button variant={ButtonVariant.Default}>Sign up</Button>
        </a>

        <SeeAllBonjoroPlans />
      </div>
    </div>
  );
};

export default SignUpForFullBonjoroExperience;
